import React from 'react';
import { Button } from '@mui/material';

import { getStatusColour } from '../../utils';
import { getStepConfig } from '../../getStepConfig';
import { usePatientIntakeStatusContext } from '../../hooks';
import { useActionPromptContext } from './ActionPromptContext.tsx';

interface CTAButtonProps extends React.ComponentProps<typeof Button> {
  onClick: () => void;
}

export const CTAButton = ({ onClick, ...props }: CTAButtonProps) => {
  const { isHealthcareProvider } = usePatientIntakeStatusContext();
  const { currentStatus, step } = useActionPromptContext();

  const handleOnClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onClick();
  };

  if (isHealthcareProvider) {
    return null;
  }

  const stepConfig = getStepConfig(step.type);
  const { cta } = stepConfig.statuses[currentStatus.status];

  const { colour } = getStatusColour(currentStatus.status);

  return (
    <Button fullWidth variant="text" color={colour} onClick={handleOnClick} {...props}>
      {cta}
    </Button>
  );
};
